/**
 * The ONLY place the Keycloak access token lives: a module variable, i.e. the
 * JavaScript heap of the tab.
 *
 * WHY NOT localStorage / sessionStorage: any script that runs in the origin can
 * read them (one XSS, one bad dependency), and what it would read is a bearer
 * that is accepted by the BFF until it expires — a stolen session, exfiltrable
 * to another host. A heap variable is not reachable from another script without
 * already executing in our closure, and it dies with the tab.
 *
 * The price is that a page reload has no session and re-runs the PKCE flow
 * (silent while the Keycloak SSO cookie is alive). That is the accepted
 * tradeoff of ADR-AUTH-04.
 *
 * Non-React consumers (apiClient, fetch call sites) read the token through
 * `getAccessToken()`; the AuthProvider is the only writer.
 */

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}

/** `Authorization` header for the current token, or `{}` when signed out. */
export function authHeader(): Record<string, string> {
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}
